"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Name = exports.Link = void 0;

var _styledComponents = _interopRequireDefault(require("styled-components")); // Copyright © VNG Realisatie 2020
// Licensed under the EUPL
//


var Link = /*#__PURE__*/_styledComponents["default"].a.withConfig({
  displayName: "indexstyles__Link",
  componentId: "sc-1lov90l-0"
})(["flex:1 1 0px;display:flex;flex-direction:column-reverse;align-items:center;width:25%;padding:0;border:none;line-height:", ";text-decoration:none;font-family:'Source Sans Pro',sans-serif;font-size:", ";font-weight:500;color:", ";background-color:", ";&:focus,&:hover,&:active{color:", ";outline:0;}&.active{color:", ";background-color:", ";svg path{fill:", ";}}"], function (p) {
  return p.theme.tokens.lineHeightText;
}, function (p) {
  return p.theme.tokens.fontSizeSmall;
}, function (p) {
  return p.theme.colorText;
}, function (p) {
  return p.theme.tokens.colorPaletteGray100;
}, function (p) {
  return p.theme.colorText;
}, function (p) {
  return p.theme.tokens.colorPaletteBlue800;
}, function (p) {
  return p.theme.tokens.colorBackground;
}, function (p) {
  return p.theme.tokens.colorPaletteBlue800;
});

exports.Link = Link;

var Name = /*#__PURE__*/_styledComponents["default"].span.withConfig({
  displayName: "indexstyles__Name",
  componentId: "sc-1lov90l-1"
})(["max-width:100%;padding:", ";overflow:hidden;text-overflow:ellipsis;text-align:center;white-space:nowrap;"], function (p) {
  return "".concat(p.theme.tokens.spacing02, " 0 ").concat(p.theme.tokens.spacing04);
});

exports.Name = Name;